export default __webpack_public_path__ + "static/media/branche-industry.0f889edb.png";